<template>
    <div>
        <div class="warpper">
            <footer-title>联系我们</footer-title>
            <div class="comName">
                <ul>
                    <li>
                        <p>普拉托</p>
                    </li>
                    <li>
                        <div>
                            <img src="~assets/image/contact/phone-icon.png" alt="联系我们">
                        </div>
                        <p>
                            <strong>0755-89589212(电话/传真)</strong>
                        </p>
                    </li>
                    <li>
                        <div>
                            <img src="~assets/image/contact/map-icon.png" alt="所在位置">
                        </div>
                        <p>
                            <strong>深圳市龙岗区横岗街道龙岗大道8288号大运软件小镇75栋2层</strong>
                        </p>
                    </li>
                    <li>
                        <div>
                            <img src="~assets/image/contact/link-icon.png" alt="">
                        </div>
                        <p>
                            <strong>www.pallet360.com</strong>
                        </p>
                    </li>
                </ul>
                <ul>
                    <li>
                        <div>
                            <img :src="localUtil.imgUrl+'home/public-account-qrcode.jpg'" style="width: 100px" />
                        </div>
                    </li>
                    <li>
                        <p>
                            <strong>扫一扫</strong>
                        </p>
                        <p>
                            <strong>关注普拉托</strong>
                        </p>
                        <p>
                            <strong>微信公众号</strong>
                        </p>
                    </li>
                </ul>
            </div>
            <!-- 地图 -->
            <div style="margin:30px 0 50px 0">
                <baidu-map class="myMap" :center="{lng: 114.303537, lat: 27.601451}" zoom="6" :scroll-wheel-zoom="true" >
                    <!-- 　<bm-geolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></bm-geolocation> -->
                    <bm-scale anchor="BMAP_ANCHOR_TOP_RIGHT" />
                    <bm-navigation anchor="BMAP_ANCHOR_BOTTOM_RIGHT"  />
                    <bm-marker :position="net" animation="BMAP_ANIMATION_BOUNCE" v-for="(net, index) in nets" :key="index">
                        <bm-label :content="net.nickName" :labelStyle="{color: 'red', fontSize:'14px',borderColor:'rgba(0, 0, 0, 0)'}" :offset="{width:10, height:-55}" />
                    </bm-marker>
                </baidu-map>
            </div>

            <ul class="partCompnty" v-for="(net, index) in nets" :key="index">
                <li>{{net.nickName}}：{{net.fullName}}</li>
                <li>地址：{{net.address}}</li>
            </ul>
        </div>
    </div>
</template>
<script>
import footerTitle from '@/components/footerTitle.vue'
export default {
    components: { footerTitle },
    data() {
        return { 
            nets: [],
        }
    },
    mounted() {
        this.queryServiceStations();
    },
    methods: {
        queryServiceStations() {
            let param = {
                url: 'http://MID-CLIENT-MALL/messageService/websiteService/queryValidServiceStations',
                body: {}
            }
            this.invoke(param).then(rs => {
                this.nets = rs.filter(({type}) => type != 'wh');
            })
        },
    }

}
</script>
<style lang="less" scoped>
.myMap {
    width: 100%;
    height: 416px;
}
/deep/.BMap_cpyCtrl {
    display: none;
}
.warpper {
    margin: 0 10px 0 10px;
    .comName {
        width: 903px;
        height: 234px;
        display: flex;
        justify-content: space-between;
        font-size: 18px;
        ul:first-child {
            width: 550px;
            li {
                width: 100%;
                height: 47px;
                line-height: 23px;
                // background: #ccc;
                display: flex;
                align-items: center;
            }
            li:nth-child(1) {
                margin-bottom: 15px;
                p {
                    font-size: 25px;
                    font-weight: bold;
                }
            }
            li:nth-child(2),
            li:nth-child(3),
            li:nth-child(4) {
                div {
                    width: 47px;
                    height: 47px;
                    border-radius: 50%;
                    background: #ff9000;
                }
                p {
                    margin-left: 10px;
                }
            }
            li:nth-child(3) {
                margin: 10px 0 10px 0;
            }
        }
        ul:last-child {
            width: 333px;
            display: flex;
            flex-direction: column;
            align-items: flex-end;
            transform: translateX(-30px);
            li:last-child {
                text-align: center;
            }
        }
    }
    dl {
        font-size: 16px;
        font-weight: 450;
        dt {
            font-size: 25px;
            font-weight: bold;
            margin-bottom: 20px;
        }
        dd {
            font-weight: bold;
            span {
                color: #ff9000;
            }
        }
    }
    .partCompnty {
        margin: 20px 0 20px 0;
        font-size: 16px;
        font-weight: bold;
        li:first-child {
            font-size: 18px;
        }
    }
    .partCompnty:last-child{
        padding-bottom: 200px;
    }
    .service {
        width: 100%;
        display: flex;
        justify-content: space-around;
        margin-bottom: 30px;
        li {
            width: 286px;
            height: 286px;
            border: 1px solid #bbbbbb;
            background: #f6f5f5;
            display: flex;
            flex-direction: column;
            align-items: center;
        }
        li {
            > div {
                margin-top: 12px;
            }
        }
        .site {
            .hotLine {
                display: flex;
                margin-left: -50px;
                span {
                    color: #ff9000;
                    padding-left: 5px;
                }
            }
        }
    }
}
</style>